import useApi from '../api';

const usePropertyService = () => {
    const { api } = useApi();
    return {
        getProperty: (id) => api.get(`property/${id}`).then((resp) => resp.data),
        getResource: () => api.get('property/get_resources').then((resp) => resp.data),

        getCountPropertyPerMonth: (id, data, filterPerActiveOrBlocked, segment) =>
            api
                .get(`property/get_properties_month/${id}`, {
                    params: {
                        data,
                        filterPerActiveOrBlocked,
                        segment
                    }
                })
                .then((resp) => resp.data),

        getPropertyByMilk: (id, data) =>
            api
                .get(`property/get_properties_milk/${id}`, {
                    params: {
                        ...data
                    }
                })
                .then((resp) => resp.data),
        getPropertyByCompany: (id, categoriesMilhoSafra, categoriesMilhoSafrinha, categoriesSojaSafra, categoriesFeijaoSafrinha) =>
            api
                .get(`property/get_properties_company/${id}`, {
                    params: {
                        categoriesMilhoSafra,
                        categoriesMilhoSafrinha,
                        categoriesSojaSafra,
                        categoriesFeijaoSafrinha
                    }
                })
                .then((resp) => resp.data),
        createProperty: (data) =>
            api
                .post('property', data, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then((resp) => resp.data),
        createPropertyGrain: (data) =>
            api
                .post('propertyGrain', data, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then((resp) => resp.data),
        getPropertyPerId: (id) => api.get(`property/${id}`).then((resp) => resp.data),
        getPropertyPerId: (id) => api.get(`property/${id}`).then((resp) => resp.data),
        getProperties: (search, orderBy, limit, optionFilter, enterpriseId, currentUserRole) =>
            api
                .get('property', {
                    params: {
                        search,
                        orderBy,
                        limit,
                        optionFilter,
                        enterpriseId,
                        currentUserRole
                    }
                })
                .then((resp) => resp.data),
        blockProperty: (propertyId) => api.post(`property/toggle_block/${propertyId}`).then((resp) => resp.data),
        update: (data, id) => {
            data.append('_method', 'put');
            return api
                .post(`property/${id}`, data, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then((resp) => resp.data);
        },
        updateGrain: (data, id) => {
            data.append('_method', 'put');
            return api
                .post(`propertyGrain/${id}`, data, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then((resp) => resp.data);
        },
        updateCpf: (id, data) => {
            return api.patch(`property/${id}/update_owner_cpf`, data).then((resp) => resp.data);
        },
        getOwnerByCPF: (cpf) => api.get(`owner/cpf/${cpf}`).then((resp) => resp.data),

        getStatistics: (id, origin) => api.get(`property/${id}/statistics?origin=${origin}`).then((resp) => resp.data),

        getPropertiesRemovalRequests: (enterpriseId, status) =>
            api.get(`property-removal-request`, { params: { enterpriseId, status } }).then((resp) => resp.data),

        updatePropertyRemovalRequest: async (data, id) => {
            return api.put(`property-removal-request/${id}`, data).then((resp) => resp.data);
        }
    };
};

export default usePropertyService;
